/**
 * Created by Yangxunwu on 2018/6/7.
 */

import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
    baseURL: process.env.BASE_API, // api的base_url
    timeout: 3600 * 1000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
    // Do something before request is sent
    if (getToken()) {
        config.headers['X-Api-Key'] = getToken() // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    }

    config.headers['Content-Type'] = 'multipart/form-data';

    return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
    response => {
        /**
         * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为token有问题，登出并返回到登录页
         * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
         */
        const res = response.data;
        if(res.code >= 40000 && res.code < 50000) {
            return response.data;

        }else if (typeof res.code !== 'undefined' && res.code !== 0) {
            Message({
                message: res.message,
                type: 'error',
                duration: 5 * 1000
            });

            // 50001:非法的token; 50002 Token 过期了;
            if (res.code === 50001 || res.code === 50002 ) {
                MessageBox.confirm('登录已失效,可以取消继续留在该页面，或者重新登录', '确定登出', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    removeToken();
                    location.reload()
                })
            }
            return Promise.reject('error');
        } else {
            return response.data;
        }
    },
    error => {
        console.log('err' + error)// for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    })

export default service



// WEBPACK FOOTER //
// ./src/utils/upload.js